import { HttpClient, HttpParams } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  CptSharedDataService,
  CptGoogleTagmanagerService,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'
import { NGXLogger } from 'ngx-logger'
import {
  KcDataService
} from '../../../kc-data.service'
import { TranslationService } from '@emilfreydigital/transifex-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { KcClientData, KcResetPasswordViewData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-revolution-reset-password',
  templateUrl: './revolution-reset-password.component.html'
})
export class RevolutionResetPasswordComponent implements OnInit {
  emailRegex: string
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly http: HttpClient,
    private readonly kcSharedDataService: CptSharedDataService,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly logger: NGXLogger,
    private readonly transifexTranslationsService: TranslationService,
    public transifexService: TransifexService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.emailRegex = this.remoteConfigService.get('regEx.emailRegEx.pattern')
    this.registrationEnabled = this.remoteConfigService.get(
      'registrationEnabled'
    )

    this.form = new FormGroup({
      email: new FormControl<string | null>(null, [
        Validators.maxLength(50),
        Validators.pattern(this.emailRegex)
      ])
    })
  }

  public clientData: KcClientData
  public viewData: KcResetPasswordViewData
  public sent: boolean
  public form

  public submitting: boolean
  public emailImage = 'assets/icons/alternate_email_24px.svg'
  public emailImageUrl = ''
  public registrationEnabled

  ngOnInit () {
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcResetPasswordViewData
    this.emailImageUrl = `${this.kcSharedDataService.getResourcesPath()}/${
      this.emailImage
    }`
  }

  public reset () {
    this.sent = true
    this.cptGtmService.sendResetPasswordGtmData()
    let body = new HttpParams()
    body = body.append('email', this.form.value.email)

    this.http.post(this.viewData.loginAction, body).subscribe(
      response => {},
      error => {
        console.error(error)
      }
    )
  }

  getTranslation (): string {
    return this.transifexTranslationsService.translate(
      'An email has been sent with a password reset link',
      {
        _key: 'customerPortal.kc.reset-password.sent',
        _tags: 'kc-forms, 3.1'
      }
    )
  }
}
